<template>
  <div
    v-scroll-lock
    class="animate__animated animate__fadeIn fixed inset-0 max-w-screen-sm mx-auto p-8 flex flex-col items-center justify-center bg-black/50 z-10"
    @click.self="handleClose"
  >
    <div
      ref="content"
      class="animate__animated animate__backInDown max-w-[460px] max-h-[500px] w-full h-full flex flex-col rounded-2xl overflow-hidden"
    >
      <div
        class="RadialGradientBackground relative w-full h-full flex flex-col justify-end"
      >
        <img
          class="absolute top-0 left-1/2 mx-auto w-full object-contain z-[-1] -translate-x-1/2 -translate-y-[30px]"
          src="/images/capino-welcome.webp"
        />

        <div class="w-full mx-auto gap-6 px-4 flex flex-col min-[400px]:px-8">
          <div class="w-full gap-4 flex flex-col justify-end text-white">
            <h2 class="font-bold text-3xl leading-tight">
              {{ $t('welcome.modal.title') }}
            </h2>

            <ul
              class="gap-2 flex flex-col text-sm leading-relaxed list-disc list-inside"
            >
              <li>{{ $t('welcome.modal.steps.1') }}</li>
              <li>{{ $t('welcome.modal.steps.2') }}</li>
              <li>{{ $t('welcome.modal.steps.3') }}</li>
            </ul>
          </div>

          <div class="pb-4 flex justify-center">
            <BaseButton color="primary-gradient" @click="handleClose">
              {{ $t('welcome.modal.gotIt') }}
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { animate } from 'motion'
import BaseButton from '@/components/Base/BaseButton.vue'

export default {
  name: 'WelcomeModal',

  components: { BaseButton },

  methods: {
    handleClose() {
      this.$refs.content.classList.add('animate__backOutDown')
      animate(this.$el, { opacity: 0 }, { duration: 0.3 }).finished.then(() => {
        this.$emit('close')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.RadialGradientBackground {
  background: radial-gradient(
    circle at 50% -20%,
    rgba(53, 53, 53, 0),
    rgba(53, 53, 53, 1) 60%
  );
}
</style>
